export default class ServiceProvider {
    constructor(categoryService, serviceService) {
        this._categoryService = categoryService;
        this._serviceService = serviceService;
    }
    get categoryService() {
        return this._categoryService;
    }
    get serviceService() {
        return this._serviceService;
    }
}
